var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDltIcn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_2222",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    y: 0.800049,
    width: 18.4,
    height: 18.4,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_2222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.16719 16.9001C5.74552 16.9001 5.38455 16.75 5.08427 16.4497C4.78399 16.1494 4.63385 15.7884 4.63385 15.3668V5.4001H3.86719V3.86676H7.70052V3.1001H12.3005V3.86676H16.1339V5.4001H15.3672V15.3668C15.3672 15.7884 15.217 16.1494 14.9168 16.4497C14.6165 16.75 14.2555 16.9001 13.8339 16.9001H6.16719ZM13.8339 5.4001H6.16719V15.3668H13.8339V5.4001ZM7.70052 13.8334H9.23385V6.93343H7.70052V13.8334ZM10.7672 13.8334H12.3005V6.93343H10.7672V13.8334Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDltIcn);
export default __webpack_public_path__ + "static/media/dltIcn.0480ba039cc4dcd438293890d084459c.svg";
export { ForwardRef as ReactComponent };